//#region Libraries
import { useState, useEffect, useRef } from "react";
//#endregion
//#region Styles
import { 
    Container, 
    Content, 
    TimeItemGroup,
    TimeItem } from "./styles";
//#endregion
//#region Utils
import { 
    getTime, 
    getText,
    getTimestamp, 
    getTimeParts 
} from "../../utils";
//#endregion

const SelectBlock = ({ 
    caption, 
    changeValue, 
    interval, value,
    ratioMinutesTime,
    disabledHours
}) => {
    //#region Hooks
    const $timeItemGroup = useRef();
    const [currentTime, setCurrentTime] = useState([]);
    //#endregion
    //#region Effects
    useEffect(() => {
        const timeParts = getTimeParts(value);
        scrollToCurrentTime(timeParts);
        setCurrentTime(timeParts);
    }, [value]);
    //#endregion
    //#region Functions
    const scrollToCurrentTime = timeParts => {
        if (value < 0) return; 
        // Definiendo la relación y el índice de posición
        let ratio = 0;
        let positionIdx = 0;
        // Buscando el elemento hacia donde se deba hacer scroll
        [...$timeItemGroup.current.children].find((child, idx) => {
            const matches = child.innerText === getText(timeParts);
            if (matches) {
                positionIdx = idx;
                ratio = child.clientHeight;
            }
            return matches;
        });
        // Calculando offset para centrar la vista del elemento de hora
        const heightContentElement = $timeItemGroup.current.parentElement.clientHeight;
        $timeItemGroup.current.parentElement.scrollTo({ top: (ratio*positionIdx) - (heightContentElement/2.5) });
    }
    //#endregion
    return (
        <Container>
            {caption && <h4>{caption}</h4>}
            <Content>
                <TimeItemGroup ref={$timeItemGroup}>
                    {getTime(interval, ratioMinutesTime)
                        .map((time, idx) => {
                            const selected = (
                                currentTime[0] === time[0] && 
                                currentTime[1] === time[1]
                            );
                            const getClassName = () => {
                                const classList = [];
                                selected && classList.push("selected");
                                disabledHours.includes(getTimestamp(time)) && classList.push("disabled");
                                return classList.join(" ");
                            }
                            return (
                                <TimeItem 
                                    key={idx}
                                    className={getClassName()}
                                    onClick={() => {
                                        changeValue(getTimestamp(time));
                                    }}>
                                    {getText(time)} 
                                </TimeItem>
                            );
                        })}
                </TimeItemGroup>
            </Content>
        </Container>
    );
};

export default SelectBlock;